/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S8_Body_PreInputs */

const tr_servis_s8_body_pre = /** @type {(inputs: Servis_S8_Body_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcı verilerini etkileyen bir ihlal tespit edilmesi halinde Şirket, olay tespit tarihinden itibaren en geç `)
};

const en_servis_s8_body_pre = /** @type {(inputs: Servis_S8_Body_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If a breach affecting User data is detected, the Company informs the User and, pursuant to KVKK Madde 12/5, the Kişisel Verileri Koruma Kurulu (Turkish Personal Data Protection Board) at the latest `)
};

const de_servis_s8_body_pre = /** @type {(inputs: Servis_S8_Body_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird ein Verstoß festgestellt, der Nutzerdaten betrifft, informiert das Unternehmen spätestens `)
};

const ru_servis_s8_body_pre = /** @type {(inputs: Servis_S8_Body_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При выявлении нарушения, затрагивающего данные Пользователя, Компания информирует Пользователя и, в соответствии с KVKK Madde 12/5, Kişisel Verileri Koruma Kurulu (турецкий Совет по защите персональных данных) не позднее чем `)
};

/**
* | output |
* | --- |
* | "If a breach affecting User data is detected, the Company informs the User and, pursuant to KVKK Madde 12/5, the Kişisel Verileri Koruma Kurulu (Turkish Perso..." |
*
* @param {Servis_S8_Body_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s8_body_pre = /** @type {((inputs?: Servis_S8_Body_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S8_Body_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s8_body_pre(inputs)
	if (locale === "de") return de_servis_s8_body_pre(inputs)
	if (locale === "ru") return ru_servis_s8_body_pre(inputs)
	return tr_servis_s8_body_pre(inputs)
});